import {
	checkOrderEmail,
	checkOrderLink,
	checkPreApproved,
	getOrderDetails,
	getOrderStats,
	orderReport,
	printLabel,
	updateInfo,
	updateOrderStatus
} from '../apis/ordersAPIs';
import { createSlice } from '@reduxjs/toolkit';
import { getOrdersList } from '../apis/ordersAPIs';
// import { showSuccessToast } from '../../app/utils/tostify';
// import { t } from 'i18next';

interface initialStateInterFace {
	error: any;
	loading: boolean;
	listingLoading: boolean;
	ordersList: Array<any>;
	currentPage: number;
	currentPageItem: number;
	count: number;
	countItem: number;
	selectedList: any;
	orderDetails: any;
	orderItemList: Array<any>;
	orderInfo: any;
	countryInfo: any;
	orderItemInfo: Array<any>;
	searchKey: string;
	page: number;
	activeTab: string;
	filter: any;
	orderReportList: any;
}

const initialState: initialStateInterFace = {
	loading: false,
	listingLoading: false,
	error: [],
	ordersList: [],
	orderReportList: [],
	currentPage: 1,
	currentPageItem: 1,
	countItem: 0,
	count: 0,
	page: 0,
	selectedList: { orders: [] },
	orderDetails: {},
	orderItemList: [],
	orderInfo: {},
	countryInfo: {},
	orderItemInfo: [],
	searchKey: '',
	activeTab: 'received',
	filter: null
};
const ordersSlice = createSlice({
	name: 'ordersSlice',
	initialState,
	reducers: {
		updateCurrentPage(state, action) {
			state.currentPage = action.payload;
		},
		handleSearchKey(state, action) {
			state.searchKey = action.payload;
		},
		updateItemsCurrentPage(state, action) {
			state.currentPageItem = action.payload;
		},
		handleFilter(state, action: any) {
			state.filter = action.payload;
		},
		handleActiveTab(state, action: any) {
			state.activeTab = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder.addCase(
			getOrdersList.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			getOrdersList.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.ordersList = action?.payload?.data?.list;
				state.count = Number(action?.payload?.data?.count) || 10;
				state.error = '';
			}
		);
		builder.addCase(
			getOrdersList.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			updateOrderStatus.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.listingLoading = true;
				state.error = '';
			}
		);
		builder.addCase(
			updateOrderStatus.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.listingLoading = false;
				state.error = '';
			}
		);
		builder.addCase(
			updateOrderStatus.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.listingLoading = false;
			}
		);
		builder.addCase(
			getOrderDetails.pending,
			(state: initialStateInterFace, action) => {
				state.error = '';
				if (
					!action.meta.arg.orderDetails &&
					(!action.meta.arg.orderItemListingType ||
						action.meta.arg.orderItemListingType !== 'ALL')
				) {
					state.orderItemList = [];
					state.listingLoading = true;
				}
				if (action.meta.arg.orderDetails) {
					state.loading = true;
					state.orderDetails = {};
				}
			}
		);
		builder.addCase(
			getOrderDetails.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.error = '';
				if (
					!action.meta.arg.orderDetails &&
					(!action.meta.arg.orderItemListingType ||
						action.meta.arg.orderItemListingType !== 'ALL')
				) {
					state.listingLoading = false;
					state.orderItemList = action?.payload?.data?.list;

					state.countItem =
						Number(action?.payload?.data?.count) || 10;
				}
				if (
					action.meta.arg.orderItemListingType ||
					action.meta.arg.orderItemListingType == 'ALL'
				) {
					state.listingLoading = false;
				}
				if (action.meta.arg.orderDetails) {
					state.loading = false;
					state.orderDetails = action?.payload?.data;
				}
			}
		);
		builder.addCase(
			getOrderDetails.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.listingLoading = false;
			}
		);
		builder.addCase(
			getOrderStats.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			getOrderStats.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
			}
		);
		builder.addCase(
			getOrderStats.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(printLabel.pending, (state: initialStateInterFace) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			printLabel.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
				// showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(printLabel.rejected, (state: initialStateInterFace) => {
			state.loading = false;
		});
		builder.addCase(updateInfo.pending, (state: initialStateInterFace) => {
			state.loading = true;
			state.listingLoading = true;
			state.error = '';
		});
		builder.addCase(
			updateInfo.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.listingLoading = false;
				state.error = '';
			}
		);
		builder.addCase(updateInfo.rejected, (state: initialStateInterFace) => {
			state.loading = false;
			state.listingLoading = false;
		});
		builder.addCase(
			checkOrderLink.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			checkOrderLink.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
			}
		);
		builder.addCase(
			checkOrderLink.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			checkOrderEmail.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			checkOrderEmail.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.orderInfo = action?.payload?.data?.orderDetails;
				state.orderItemInfo = action?.payload?.data?.orderItems;
				state.countryInfo = action?.payload?.data?.countryInfo;
				state.error = '';
			}
		);
		builder.addCase(
			checkOrderEmail.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			orderReport.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			orderReport.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.orderReportList = action?.payload?.data?.list;
				state.error = '';
			}
		);
		builder.addCase(
			orderReport.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			checkPreApproved.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			checkPreApproved.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
			}
		);
		builder.addCase(
			checkPreApproved.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
	}
});
export const {
	updateCurrentPage,
	handleSearchKey,
	handleFilter,
	handleActiveTab
} = ordersSlice.actions;
export default ordersSlice.reducer;
